var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPolicy = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#5f6368",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-71.63Q337.47-107.3 244.67-234.19q-92.8-126.89-92.8-281.81v-249.61L480-888.37l328.13 122.76V-516q0 64.24-16.74 124.91-16.74 60.68-48.69 115.16l-123.5-123.5q10.52-18.53 15.66-38.79Q640-458.48 640-480q0-66-47-113t-113-47q-66 0-113 47t-47 113q0 66 47 113t113 47q20.76 0 40.78-5.14t37.79-15.66L693.3-207.07q-42.71 49.48-96.53 84.72Q542.96-87.11 480-71.63Zm-.03-331.96q-31.54 0-53.96-22.45-22.42-22.46-22.42-53.99 0-31.54 22.45-53.96 22.46-22.42 53.99-22.42 31.54 0 53.96 22.45 22.42 22.46 22.42 53.99 0 31.54-22.45 53.96-22.46 22.42-53.99 22.42Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPolicy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/policy.aca05b37.svg";
export { ForwardRef as ReactComponent };